<template>
  <div class="container" >
    <HeadCont />
    <SwiperCont />
    <router-view ></router-view>
    <FooterCont v-show="!loading"/>
  </div>
</template>

<script>
import HeadCont from "@/components/headCont/index.vue";
import FooterCont from "@/components/footerCont/index.vue";
import SwiperCont from "@/components/swiperCont/index.vue";

export default {
  components: {
    HeadCont,
    FooterCont,
    SwiperCont,
  },
  filters: {},
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    $route(to, from) {
      this.getRouter();
    },
  },
  computed: {},
  mounted() {
    this.loadingFlase();
  },
  created() {},
  methods: {
    loadingFlase() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    getRouter() {
      this.loading=true
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./index.scss";
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue